export default "L'Éco-PTZ collectif permet aux copropriétés de financer leurs travaux de rénovation énergétique jusqu'à 50 000 € par logement, sans intérêts. Conditions et démarche en assemblée générale.";
